import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withAppContext } from '../../contexts/app';

import ImageUploader from '../ImageUploader';

class GetStarted extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="cta-get-started">
        <div className="container">
          <h2>Get an instant second opinion.</h2>
          <p>Take a photo and get answers now.</p>

          <ImageUploader
            className="button button--gradient button--large"
            label="Start your scan"
            onUpload={this.onImageUpload.bind(this)}
          />
        </div>
      </div>
    );
  }

  onImageUpload(image) {
    this.props.app.onImageUpload(image);
  }
}

GetStarted.defaultProps = {};

GetStarted.propTypes = {
  app: PropTypes.object.isRequired
};

export default withAppContext(GetStarted);
